import store from '../store'
import router from '../router'

function navRouterState (item, flag) {
    if (!item) {
        return
    }
    let type = item.type
    if (type === '0') {
        store.state.isFlagLiClass = null
        store.state.isFlagSpanClass = item.path
        store.state.iconNavHeader = []
        !flag && router.push({
            name: item.path
        })
    } else if (type === '1') {
        store.state.isFlagLiClass = item.path
        store.state.isFlagSpanClass = null
        store.state.iconNavHeader = []
        !flag && router.push({
            name: item.path
        })
    } else {
        !flag && router.push({
            name: item.path
        })
        store.state.isFlagSpanClass = null
        store.state.isFlagLiClass = item.path
    }

    if (item.from && item.type !== '2') {
        // 这里面是第二层 nav
        // console.log(item.from)
        store.state.isFlagSpanClass = item.from
    }
    // 让专案分析拥有第二层导航
    // if (item.contains && item.contains.length && !item.contains.some(element => { element === store.state.isFlagLiClass })) {
    //   store.state.isFlagLiClass = item.path
    // }
}

export {
    navRouterState
}
